const RightArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
    <g clipPath="url(#clip0_168_629)">
      <path
        d="M2.08 1L6 4.5L2.08 8"
        stroke="#FC4C4C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_168_629">
        <rect width="8" height="8" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default RightArrowIcon;
